import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class TimeOptions extends Component {
    render() {
        return (
            strings.options.map((option, i) => <option key={i} value={option.value}>{option.label}</option>)
        )
    }
}
 
export default TimeOptions;


// WEBPACK FOOTER //
// ./src/components/Common/TimeBeforeOptions/TimeBeforeOptions.js